import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import LanguageSwitcher from './LanguageSwitcher';

export default function Header(props) {
  return (
    <header id='top' className="p-4">
      <LanguageSwitcher onLanguageChange={props.onLanguageChange}  />
      {/* <Row
        className="mb-3"
        style={{ maxWidth: '1200px', marginInline: 'auto' }}
      >
        <Col className="d-flex align-items-center">
          <img src="/images/logo_no tagline.png" alt="logo" className='logo'/>
        </Col>
        <Col className="d-flex flex-column align-items-end ">
          <p
            className="mb-2 pe-3"
          >
            FOLLOW US
          </p>
          <div className="d-flex">
            <button
              style={{
                border: 'none',
                fontSize: '1.2rem'
              }}
            >
              <i className="fab fa-facebook-square"></i>
            </button>
            <button
              style={{
                border: 'none',
                fontSize: '1.2rem'
              }}
            >
              <i className="fab fa-instagram-square"></i>
            </button>
            <button
              style={{
                border: 'none',
                fontSize: '1.2rem'
              }}
            >
              <i className="fab fa-youtube-square"></i>
            </button>
            <button
              style={{
                border: 'none',
                fontSize: '1.2rem'
              }}
            >
              <i className="fab fa-twitter-square"></i>
            </button>
          </div>
        </Col>
      </Row> */}
    </header>
  );
}
